var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { Select, Store, Actions, ofActionDispatched } from '@ngxs/store';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
import { Observable, Subject } from 'rxjs';
import { FormBuilder, Validators } from '@angular/forms';
import { SaveBookmark, SaveBookmarkSuccess, SaveBookmarkFail } from 'src/app/bookmarks/state/bookmarks.actions';
import { OrganizationsService } from 'src/app/organizations/organizations.service';
import { map, debounceTime } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { GetCollections } from 'src/app/organizations/state/organizations.actions';
import { BookmarksState } from 'src/app/bookmarks/state/bookmarks.state';
export var SaveBookmarkDialogMode;
(function (SaveBookmarkDialogMode) {
    SaveBookmarkDialogMode[SaveBookmarkDialogMode["SaveStory"] = 0] = "SaveStory";
    SaveBookmarkDialogMode[SaveBookmarkDialogMode["Manage"] = 1] = "Manage";
})(SaveBookmarkDialogMode || (SaveBookmarkDialogMode = {}));
var SaveBookmarkDialogComponent = /** @class */ (function () {
    function SaveBookmarkDialogComponent(store, fb, dialogRef, data, snackBar, actions, organizationsService) {
        var _this = this;
        this.store = store;
        this.fb = fb;
        this.dialogRef = dialogRef;
        this.data = data;
        this.snackBar = snackBar;
        this.actions = actions;
        this.organizationsService = organizationsService;
        this.saveDebounce = new Subject();
        this.settings = {
            mode: SaveBookmarkDialogMode.SaveStory
        };
        this.ngUnsubscribe = new Subject();
        this.settings = __assign({}, this.settings, data);
        this.form = this.fb.group({
            title: ['', [Validators.required, Validators.maxLength(60)]],
            collection: [null],
            groupAccess: [null],
            publicAccess: [false]
        });
        // Listen for bookmark actions
        this.actions
            .pipe(ofActionDispatched(SaveBookmarkSuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(function (response) { return _this.handleSaveSuccess(response); });
        this.actions
            .pipe(ofActionDispatched(SaveBookmarkFail), takeUntil(this.ngUnsubscribe))
            .subscribe(function (response) { return _this.handleSaveFailure(response); });
        this.saveDebounce
            .pipe(debounceTime(100), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.saveBookmark();
        });
    }
    Object.defineProperty(SaveBookmarkDialogComponent.prototype, "dialogTitle", {
        get: function () {
            return this.settings.title || (this.settings.mode === SaveBookmarkDialogMode.Manage ? 'Manage' : 'Save');
        },
        enumerable: true,
        configurable: true
    });
    SaveBookmarkDialogComponent.prototype.ngOnInit = function () {
        // populate group collections
        var organization = this.store.selectSnapshot(OrganizationsState.getOrganization);
        if (organization) {
            this.store.dispatch(new GetCollections(organization.id));
        }
        // set form
        var bookmark = this.settings.bookmark;
        var title = bookmark ? bookmark.title : (this.settings.bookmarkTitle ? this.settings.bookmarkTitle : '');
        // group access state
        var groupAccess = bookmark ? this.getGroupAccess(bookmark) : null;
        var groupEdit = false;
        var groupView = false;
        if (groupAccess) { // set group access via data
            groupEdit = groupAccess.member_edit;
            groupView = !groupEdit && groupAccess.visible;
        }
        else if (!bookmark && organization) { // default group users
            groupEdit = false;
            groupView = true;
        }
        // public access: non-group users
        var publicAccess = !this.isGroupUser() && (bookmark && bookmark.tags.includes('public'));
        this.form.patchValue({
            title: title,
            groupAccess: groupEdit ? 'edit' : (groupView ? 'view' : ''),
            publicAccess: publicAccess
        });
        // set mode
        this.isNew = true;
        this.isOwner = true;
        if (bookmark) {
            if (bookmark.is_owner) {
                this.isNew = false;
                this.isOwner = true;
            }
            else {
                var isEditable = bookmark.group_access.some(function (access) { return access.member_edit === true; });
                this.isNew = !isEditable;
                this.isOwner = this.isNew;
            }
        }
        // setup group access
        this.initGroupAccess();
        // setup collections
        this.initCollections();
        // set group access
        this.toggleGroupAccess(groupView, groupEdit);
    };
    SaveBookmarkDialogComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SaveBookmarkDialogComponent.prototype.initGroupAccess = function () {
        var _this = this;
        var groupAccessField = this.form.get('groupAccess');
        // set collections: via group access
        groupAccessField.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (groupAccess) {
            var groupView = groupAccess === 'view';
            var groupEdit = groupAccess === 'edit';
            _this.toggleGroupAccess(groupView, groupEdit);
        });
    };
    SaveBookmarkDialogComponent.prototype.initCollections = function () {
        var _this = this;
        var bookmark = this.settings.bookmark;
        var formCollection = this.form.get('collection');
        formCollection.disable();
        var organization = this.store.selectSnapshot(OrganizationsState.getOrganization);
        if (organization && bookmark) {
            var collection$ = this.organizationsService.getCollectionsByContent(organization.id, {
                content_type: bookmark.type,
                content_id: bookmark.id
            });
            collection$
                .pipe(map(function (contentCollections) { return contentCollections[0]; }), takeUntil(this.ngUnsubscribe))
                .subscribe(function (contentCollection) {
                _this.currentCollection = contentCollection;
                var currentCollectionId = _this.currentCollection ? _this.currentCollection.collection_id : null;
                _this.form.patchValue({
                    collection: currentCollectionId
                });
            });
        }
    };
    SaveBookmarkDialogComponent.prototype.toggleGroupAccess = function (groupView, groupEdit) {
        var collection = this.form.get('collection');
        var canEditCollections = this.isOwner || this.isNew;
        var isGroupAccess = groupView || groupEdit;
        // clear selection
        if (!isGroupAccess) {
            collection.setValue(null);
        }
        // set enabled state   
        if (canEditCollections && isGroupAccess) {
            collection.enable();
        }
        else {
            collection.disable();
        }
    };
    SaveBookmarkDialogComponent.prototype.handleSubmit = function () {
        if (this.form.valid) {
            this.saveDebounce.next();
        }
    };
    SaveBookmarkDialogComponent.prototype.saveBookmark = function () {
        var bookmarkEntry = this.getBookmarkEntry();
        var includeIndex = this.settings.mode === SaveBookmarkDialogMode.SaveStory;
        this.store.dispatch(new SaveBookmark(bookmarkEntry, false, includeIndex));
    };
    SaveBookmarkDialogComponent.prototype.handleSaveSuccess = function (response) {
        var bookmark = response.bookmark;
        var message = this.settings.mode === SaveBookmarkDialogMode.Manage ?
            "Your updates to \"" + bookmark.title + "\" have been saved to your dashboard." :
            "\"" + bookmark.title + "\" saved to your dashboard.";
        this.snackBar.open(message);
        this.dialogRef.close(bookmark);
    };
    SaveBookmarkDialogComponent.prototype.handleSaveFailure = function (response) {
        this.snackBar.open("Unable to save bookmark \"" + response.bookmarkEntry.title + "\". Please try again.");
    };
    SaveBookmarkDialogComponent.prototype.getBookmarkEntry = function () {
        var bookmark = this.settings.bookmark;
        var _a = this.form.value, title = _a.title, collection = _a.collection, groupAccess = _a.groupAccess, publicAccess = _a.publicAccess;
        var groupView = groupAccess === 'view';
        var groupEdit = groupAccess === 'edit';
        var isPublicAccess = this.isGroupUser() ? null : publicAccess;
        var addGroupAccess = [];
        var removeGroupAccess = [];
        var addCollection;
        var removeCollection;
        // owner: manage permissions + collections
        if (this.isOwner) {
            var groupAccessPermission = this.createGroupAccess(groupView, groupEdit);
            if (groupAccessPermission) {
                // set group access if selected
                addGroupAccess = [groupAccessPermission];
            }
            else {
                // remove all existing access if none selected
                removeGroupAccess = bookmark ? bookmark.group_access : [];
            }
            // handle collections
            var collections = this.store.selectSnapshot(OrganizationsState.getCollections) || [];
            var selectedCollectionId_1 = parseInt(collection, 10);
            var selectedCollection = collections.find(function (c) { return c.collection_id === selectedCollectionId_1; });
            if (this.currentCollection) { // update collection
                var isCurrentSelected = this.currentCollection.collection_id === selectedCollectionId_1;
                if (!isCurrentSelected) { // only update when changing
                    addCollection = selectedCollection;
                    removeCollection = this.currentCollection;
                }
            }
            else if (selectedCollection) { // add optional collection
                addCollection = selectedCollection;
            }
        }
        return {
            isOwner: bookmark ? bookmark.is_owner : true,
            id: bookmark ? bookmark.id : null,
            title: title,
            add_group_access: addGroupAccess,
            remove_group_access: removeGroupAccess,
            addCollection: addCollection,
            removeCollection: removeCollection,
            public_access: isPublicAccess
        };
    };
    SaveBookmarkDialogComponent.prototype.getGroupAccess = function (bookmark) {
        var organization = this.store.selectSnapshot(OrganizationsState.getOrganization);
        var groupAccess = null;
        if (organization && bookmark.group_access) {
            var organizationId_1 = organization.id;
            groupAccess = bookmark.group_access.find(function (bookmarkAccessLevel) { return bookmarkAccessLevel.group_id === organizationId_1; });
        }
        return groupAccess;
    };
    SaveBookmarkDialogComponent.prototype.createGroupAccess = function (groupView, groupEdit) {
        var organization = this.store.selectSnapshot(OrganizationsState.getOrganization);
        var isValidAccess = groupView || groupEdit;
        if (organization && isValidAccess) {
            return {
                group_id: organization.id,
                member_edit: groupEdit,
                visible: groupView || groupEdit
            };
        }
        else {
            return null;
        }
    };
    SaveBookmarkDialogComponent.prototype.isGroupUser = function () {
        return !!this.store.selectSnapshot(OrganizationsState.getOrganization);
    };
    __decorate([
        Select(OrganizationsState.getOrganization),
        __metadata("design:type", Observable)
    ], SaveBookmarkDialogComponent.prototype, "organization$", void 0);
    __decorate([
        Select(OrganizationsState.getCollections),
        __metadata("design:type", Observable)
    ], SaveBookmarkDialogComponent.prototype, "collections$", void 0);
    __decorate([
        Select(BookmarksState.getSaving),
        __metadata("design:type", Observable)
    ], SaveBookmarkDialogComponent.prototype, "saving$", void 0);
    return SaveBookmarkDialogComponent;
}());
export { SaveBookmarkDialogComponent };
